module.exports = __webpack_public_path__ + "static/media/293222.ebdef273.png";